export default function toBool(str = '') {
  return str ? str.toLowerCase() === 'true' : false;
}
